import Cookies from 'js-cookie'

const TokenKey = 'Client-Token'
const cookieBase = { path: '/' }

/** 后端返回的 token 已含 Bearer 前缀，统一格式避免 Authorization 异常 */
export function normalizeToken(token: string): string {
  const t = token.trim()
  if (!t) return t
  return t.startsWith('Bearer ') ? t : `Bearer ${t}`
}

export function getToken(): string | undefined {
  const t = Cookies.get(TokenKey)
  return t ? normalizeToken(t) : undefined
}

export function setToken(token: string) {
  return Cookies.set(TokenKey, normalizeToken(token), cookieBase)
}

export function removeToken() {
  Cookies.remove(TokenKey, cookieBase)
  Cookies.remove(TokenKey, { path: '/index' })
  Cookies.remove(TokenKey)
}
